import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import { SelectObject } from '@components/SelectObject'
import FilterGridItem from '@components/toolbar/FilterGridItem'

import { BijlageTemplatesByProcesstap } from '../../../templates/components/BijlageTemplatesByProcesstap'
import { StyledError } from '../../../theme/components/StyledError'
import { useTemplatesSearch } from '../hooks/useTemplatesSearch'
import type { ContractinstellingenBijlagenSearchFilters } from '../types/ContractinstellingenBijlagenSearch'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'
import {
  filterTemplatesBySet,
  getTemplateSetOptions,
} from '../util/template-sets'

export { ContractinstellingenBijlagen }

type Props = {
  filters: ContractinstellingenSearchFilters
  bijlagenFilters: ContractinstellingenBijlagenSearchFilters
  onChangeBijlagenFilters: (
    filters: ContractinstellingenBijlagenSearchFilters,
  ) => void
}

const ContractinstellingenBijlagen = ({
  filters,
  bijlagenFilters,
  onChangeBijlagenFilters,
}: Props) => {
  const {
    data: { bijlageTemplates },
    isLoading,
    error,
  } = useTemplatesSearch({ filters })

  const { templateSet } = bijlagenFilters
  const templateSets = getTemplateSetOptions(bijlageTemplates)
  const hasSingleTemplateSet = templateSets.length === 1
  const showTemplateSetSelect =
    !!filters.verantwoordelijke && !hasSingleTemplateSet
  const selectedTemplateSet = hasSingleTemplateSet
    ? templateSets[0]
    : templateSet

  return (
    <>
      {showTemplateSetSelect && (
        <Grid spacing={2} container sx={{ marginBottom: 4 }}>
          <FilterGridItem>
            <SelectObject
              label="Combi en type werk"
              value={templateSet}
              options={templateSets}
              isOptionEqualToValue={(option, value) =>
                option.code === value.code
              }
              onChange={(value) =>
                onChangeBijlagenFilters({ templateSet: value })
              }
              variant="outlined"
              sx={{ minWidth: 600 }}
            />
          </FilterGridItem>
        </Grid>
      )}

      <StyledError error={error} />

      {isLoading && (
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}

      {selectedTemplateSet ? (
        <BijlageTemplatesByProcesstap
          templates={filterTemplatesBySet(
            bijlageTemplates,
            selectedTemplateSet,
          )}
        />
      ) : (
        !isLoading && (
          <Typography>
            {filters.verantwoordelijke
              ? 'Selecteer een combi en type werk.'
              : 'Selecteer een verantwoordelijke.'}
          </Typography>
        )
      )}
    </>
  )
}
